<div class="row padding-bottom">
  <div class="col-md-12">
    <p><b>NOTE</b> These are hardcoded in app.component.ts so ONLY change the names unless you update that also.</p>
    <p-dataTable [value]="navItems | async"
                 selectionMode="single"
                 [(selection)]="selectedNavItem"
                 (onRowSelect)="onNavItemRowSelect($event)"
                 [responsive]="true"
                 class="text-center">
      <p-header>Navigation Bar Menu</p-header>
      <p-column field="name"
                header="Name"></p-column>
      <p-column field="route"
                header="Route"></p-column>
      <p-column field="external"
                header="External"></p-column>
      <p-column field="isDropDown"
                header="Dropdown?"></p-column>
      <p-column field="metaTitle"
                header="Meta Title"></p-column>
      <p-footer>
        <div class="ui-helper-clearfix"
             style="width:100%">
          <button *ngIf="!locationData"
                  type="button"
                  class="btn btn-primary float-left"
                  (click)="showNavItemDialogToAdd()">
            <i class="fa fa-plus"
               aria-hidden="true"></i> Add
          </button>
          <button *ngIf="!locationData; else locationButton"
                  type="button"
                  class="btn btn-secondary float-right"
                  (click)="setDefaults()">
            <i class="fa fa-refresh"
               aria-hidden="true"></i> Set Meta Defaults
          </button>
          <button *ngIf="sizeGuideRouteIndex > -1"
                  type="button"
                  class="btn btn-default float-right mr-2"
                  (click)="replaceSizeGuideWithDropdown()">
            <i class="fa fa-exchange"
               aria-hidden="true"></i> Convert Size Guide to Dropdown
          </button>
          <ng-template #locationButton>
            <button type="button"
                    class="btn btn-secondary float-right"
                    color="accent"
                    (click)="generateLocationMeta()">
              <i class="fa fa-refresh"
                 aria-hidden="true"></i> Generate Location Meta
            </button>
          </ng-template>
        </div>
      </p-footer>
    </p-dataTable>
  </div>
</div>

<p-dialog header="Navigation Item Details"
          [(visible)]="displayNavItemDialog"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          [positionTop]="100"
          [width]="900"
          [dismissableMask]="true">
  <div class="ui-grid ui-grid-responsive ui-fluid"
       *ngIf="navItem">
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="isDropDown">Dropdown?</label>
      </div>
      <div class="ui-grid-col-8">
        <md-slide-toggle id="isDropDown"
                         [(ngModel)]="navItem.isDropDown"></md-slide-toggle>
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="name">Name</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="name"
               [(ngModel)]="navItem.name" />
      </div>
    </div>
    <div *ngIf="navItem.isDropDown"
         class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="canonical">Canonical</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="canonical"
               [(ngModel)]="navItem.canonical" />
      </div>
    </div>
    <div *ngIf="!navItem.isDropDown">
      <div class="ui-grid-row sm-padding-top">
        <div class="ui-grid-col-4">
          <label for="route">Route</label>
        </div>
        <div class="ui-grid-col-8">
          <input pInputText
                 id="route"
                 [(ngModel)]="navItem.route" />
        </div>
      </div>
      <div class="ui-grid-row sm-padding-top">
        <div class="ui-grid-col-4">
          <label for="external">External</label>
        </div>
        <div class="ui-grid-col-8">
          <md-slide-toggle id="external"
                           [(ngModel)]="navItem.external"></md-slide-toggle>
        </div>
      </div>
      <div class="ui-grid-row sm-padding-top">
        <div class="ui-grid-col-4">
          <label for="topLevel">Top Level (no location key)</label>
        </div>
        <div class="ui-grid-col-8">
          <md-slide-toggle id="topLevel"
                           [(ngModel)]="navItem.topLevel"></md-slide-toggle>
        </div>
      </div>
      <div class="ui-grid-row sm-padding-top">
        <div class="ui-grid-col-4">
          <label for="metaTitle">Meta Title</label>
        </div>
        <div class="ui-grid-col-8">
          <input pInputText
                 id="metaTitle"
                 [(ngModel)]="navItem.metaTitle" />
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-3">
          <label for="metaImg">Meta Image</label>
        </div>
        <div class="col-md-9">
          <input pInputText
                 id="metaImg"
                 [(ngModel)]="navItem.metaImage" />
        </div>
        <p class="text-center">Location image is used by default. If you put one here it overides that.</p>

      </div>
      <div class="row sm-padding-top">
        <div class="col-md-3">
          <label for="metaImageAlt">Meta Image Alt</label>
        </div>
        <div class="col-md-9">
          <input pInputText
                 id="metaImageAlt"
                 [(ngModel)]="navItem.metaImageAlt" />
        </div>
      </div>
      <div class="ui-grid-row sm-padding-top">
        <div class="ui-grid-col-12">
          <label for="metaDescription">Meta Description</label>
        </div>
      </div>
      <div class="ui-grid-row sm-padding-top">
        <div class="ui-grid-col-12">
          <textarea pInputTextarea
                    id="metaDescription"
                    class="full-width text-area-box"
                    [(ngModel)]="navItem.metaDescription"></textarea>
        </div>
      </div>
    </div>
    <div style="overflow:auto;max-height:55vh"
         *ngIf="navItem.isDropDown">
      <div class="sm-padding-top"
           *ngFor="let child of navItem.children; let index = index; let last = last">
        <div class="text-center sm-padding-top">
          <button *ngIf="!locationData"
                  class="btn btn-secondary"
                  color="accent"
                  (click)="deleteChild(index)">
            <i class="fa fa-trash"
               aria-hidden="true"></i>&nbsp;Delete
          </button>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label>Name</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   [(ngModel)]="child.name" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label>Route</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   [(ngModel)]="child.route" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label>External</label>
          </div>
          <div class="ui-grid-col-8">
            <md-slide-toggle [(ngModel)]="child.external"></md-slide-toggle>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label>Top Level (no location key)</label>
          </div>
          <div class="ui-grid-col-8">
            <md-slide-toggle [(ngModel)]="child.topLevel"></md-slide-toggle>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label>Meta Title</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   [(ngModel)]="child.metaTitle" />
          </div>
        </div>

        <div class="row sm-padding-top">
          <div class="col-md-3">
            <label>Meta Image</label>
          </div>
          <div class="col-md-9">
            <input pInputText
                   [(ngModel)]="child.metaImage" />
          </div>
          <p class="text-center">
            Location image is used by default. If you put one here it overides that.
          </p>
        </div>
        <div class="row sm-padding-top">
          <div class="col-md-3">
            <label>Meta Image Alt</label>
          </div>
          <div class="col-md-9">
            <input pInputText
                   [(ngModel)]="child.metaImageAlt" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-12">
            <label>Meta Description</label>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-12">
            <textarea pInputTextarea
                      class="full-width text-area-box"
                      [(ngModel)]="child.metaDescription"></textarea>
          </div>
        </div>
        <hr *ngIf="!last">
      </div>
      <div class="text-center">
        <button class="btn btn-primary"
                color="primary"
                (click)="newChild()">
          <i class="fa fa-plus"
             aria-hidden="true"></i></button>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button class="btn btn-secondary"
              *ngIf="!newNavItem && !locationData"
              style="float:left"
              (click)="deleteNavItem()"><i class="fa fa-close"
           aria-hidden="true"></i> Delete</button>
      <button class="btn btn-primary"
              color="primary"
              (click)="saveNavItem()"><i class="fa fa-check"
           aria-hidden="true"></i> Save</button>
    </div>
  </p-footer>
</p-dialog>



// WEBPACK FOOTER //
// ./src/ng2/app/components/navigation-item/navigation-item.component.html